import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StoresService } from 'src/app/home/services/stores.service';
import { ImplantsModalComponent } from 'src/app/shared/implants-modal/implants-modal.component';

@Component({
  selector: 'app-reset-status-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './reset-status-modal.component.html',
  styleUrls: ['./reset-status-modal.component.scss', '../../../app.component.scss', '../../../shared/base-modal.style.scss']
})
export class ResetStatusModalComponent implements OnInit{
  public dialogData: any;

  constructor(
    public dialogRef: MatDialogRef<ResetStatusModalComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private storeService: StoresService
  ){
    if(data){
      this.dialogData = data;
    }
  }

  ngOnInit(): void {
  }

  openImplantDialog(storeId: string|number, implantId: string|number): void {
    const dialogRef = this.dialog.open(ImplantsModalComponent, {
      data: {
        storeId,
        implantId
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  submit(){
    let bodyContent = {
      implant_id: [this.dialogData.implantId]
    }

    this.storeService.resetStatus(this.dialogData.storeId, bodyContent).subscribe({
      next: (res) => {
        if (res.data) {
          if (res.data.updated_products.length !== 0) {
            this.dialogRef.close({ status: true, message: 'Product status has been updated successfully'});
          }else if(res.data.nonupdated_products.length !== 0){
            this.dialogRef.close({ status: false, message: "Something went wrong can't update the product."});
          }else if(res.data.nonconsumed_products.length !== 0){
            this.dialogRef.close({ status: false, message: "This product not consumed yet."});
          }else if(res.data.unknown_products.length !== 0){
            this.dialogRef.close({ status: false, message: "This product is not exists."});
          }else{
            this.dialogRef.close({ status: false, message: "Oops something went wrong."});
          }
        }else{
          this.dialogRef.close({ status: false, message: "Oops something went wrong."});
        }
      },
      error: (error) => {
        if (error) {
          this.dialogRef.close({ status: false, message: "Oops something went wrong."});
        }
      },
      complete: () => {return} 
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}